// this is an autogenerated file from App/Account/Content/Settings/Content/DocumentTemplates/Templates/LocationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_DocumentTemplates_Templates_LocationChooser{
  session_user_locations(order_by: { name: asc }) {
    _id
    text: name
  }
}

`